import API from '../../lib/api'

export function createGame () {
  return API.games.create()
}

export function updateGame (params) {
  return params
}



/** WEBPACK FOOTER **
 ** ./web/static/app/actions/game.js
 **/